var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot_category"},[_c('div',{staticClass:"dot_wrap"},[_c('div',{staticClass:"commom_dot"},[_c('p',{staticClass:"dot_two"},[_vm._v(_vm._s(_vm.textTwo))])]),_c('div',{staticClass:"commom_dot"},[_c('p',{staticClass:"dot_one"},[_vm._v(_vm._s(_vm.textOne))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }